import { useState } from 'react'
import { useIntl } from 'react-intl'

import { Bars3Icon } from '@gto/icons-react/outline/bars-3'
import { ArrowLeftEndOnRectangleIcon } from '@gto/icons-react/solid/arrow-left-end-on-rectangle'
import { IconGtoWizardLogo } from '@gto/ui/assets'
import { Divider } from '@gto/ui/divider'
import { Drawer } from '@gto/ui/drawer'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { IconButton } from '@gto/ui/icon-button'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'

import { NavList } from './nav-list'

export const MobileNav = () => {
  const { formatMessage } = useIntl()
  const isMdAndLarger = useMediaQuery('up', 'md')
  const { partner, onLogout } = useAuth()
  const [open, setOpen] = useState(false)

  if (isMdAndLarger) {
    return null
  }

  return (
    <>
      <div className="flex items-center justify-between border-b border-divider bg-gradient-paper1 px-4 py-2">
        <IconButton
          edge="start"
          onClick={() => setOpen(true)}
        >
          <Bars3Icon />
        </IconButton>
        <IconGtoWizardLogo
          style={{ height: 20, width: 'auto', color: 'var(--clr-primary, #AAFBB2)' }}
        />
        <div />
      </div>

      <Drawer.Root
        open={open}
        swipeDirection="left"
        onOpenChange={(nextOpen) => {
          if (!nextOpen) {
            setOpen(false)
          }
        }}
      >
        <Drawer.Portal>
          <Drawer.Backdrop />
          <Drawer.Popup
            aria-label={formatMessage({ id: 'nav.menu' })}
            className="max-w-[100px] items-center border border-divider bg-gradient-paper1"
            side="left"
          >
            <div className="flex flex-col items-center p-2 text-center">
              <IconGtoWizardLogo
                style={{ height: 20, width: 'auto', color: 'var(--clr-primary, #AAFBB2)' }}
              />
              {partner && (
                <Typography
                  className="mt-0 text-[0.6rem]"
                  color="text.secondary"
                  variant="caption"
                >
                  {partner.display_name}
                </Typography>
              )}
            </div>

            <Divider />

            <NavList onNavigate={() => setOpen(false)} />

            <div />

            <Divider />

            <div>
              <IconButton
                className="hover:bg-error-main/8 text-text-secondary hover:text-error-main"
                size="medium"
                onClick={() => onLogout()}
              >
                <ArrowLeftEndOnRectangleIcon
                  height={20}
                  width={20}
                />
              </IconButton>
            </div>
          </Drawer.Popup>
        </Drawer.Portal>
      </Drawer.Root>
    </>
  )
}
